import * as React from "react";
import { MenuItem, Collapse, Typography, Badge, alpha } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {
  ExpandLess,
  ExpandMore,
  PersonOutlined,
  GroupsOutlined,
  InsertChartOutlined,
  BusinessOutlined,
  NotificationsOutlined,
  // EventIcon,
  PeopleOutlined,
  DashboardOutlined,
  TextSnippetOutlined,
  Redeem,
  PsychologyAltOutlined,
  BusinessCenterOutlined,
  AssignmentOutlined,      // For reports
  HistoryOutlined,         // For history
  AdminPanelSettingsOutlined, // For roles
  CardMembershipOutlined,  // For cards
  WorkspacePremiumOutlined, // For tiers
  HomeOutlined,            // For CMS homepage
  StoreOutlined,           // For CMS store page
  LocalOfferOutlined,      // For CMS offers page
  EventAvailableOutlined,  // For CMS events page
} from "@mui/icons-material";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import DomainVerificationOutlinedIcon from '@mui/icons-material/DomainVerificationOutlined';
import RuleFolderOutlinedIcon from '@mui/icons-material/RuleFolderOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import WebIcon from '@mui/icons-material/Web';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import EventIcon from '@mui/icons-material/Event';
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Fragment } from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router";
import { routeKeys } from "./listmap";
import { useDispatch, useSelector } from "react-redux";
import { open } from "../../../Redux/collapseSlice";
import { t } from "i18next";

function SideList() {
  const theme = useTheme();
  const isRtl = theme.direction === "rtl";
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authenticationValues.currentUser);
  const moderationCount = useSelector(
    (state) => state.moderationCountValues.moderationCount
  );
  const openLoyaltyMember = useSelector(
    (state) => state.collapseValues.loyalty
  );
  const openModeration = useSelector(
    (state) => state.collapseValues.moderation
  );
  const openManagement = useSelector(
    (state) => state.collapseValues.management
  );
  const openReporting = useSelector((state) => state.collapseValues.reporting);
  const openCMS = useSelector((state) => state.collapseValues.cms);
  const permissions = user.permissions;
  const roles = user.userRoles?.map((roleItem) => roleItem?.role?.name) || [];
  const navigate = useNavigate();
  const openValue = {
    openReporting: openReporting,
    openManagement: openManagement,
    openLoyaltyMember: openLoyaltyMember,
    openModeration: openModeration,
    openCMS: openCMS,
  };

  const listItemsAll = [
    {
      item: {
        key: "dashboard",
        text: t("dashboard"),
        multiLevel: false,
        collapse: null,
        icon: DashboardOutlined,
        childeren: [],
      },
    },
    {
      item: {
        key: "reporting",
        text: t("reporting"),
        multiLevel: true,
        collapse: "openReporting",
        icon: TextSnippetOutlined,
        childeren: [
          { key: "offerReport", text: t("reportingoffers"), icon: AssignmentOutlined },
          { key: "memberReport", text: t("reportingmembers"), icon: PeopleOutlined },
        ],
      },
    },
    {
      item: {
        key: "management",
        text: t("management"),
        multiLevel: true,
        icon: PersonOutlined,
        collapse: "openManagement",
        childeren: [
          { key: "userPermission", text: t("usermanagement"), icon: ManageAccountsOutlinedIcon },
          { key: "rolePermission", text: t("rolemanagement"), icon: AdminPanelSettingsOutlined },
        ],
      },
    },
    {
      item: {
        key: "clients",
        text: t("clients"),
        multiLevel: false,
        icon: BusinessCenterOutlined,
        collapse: null,
        childeren: [],
      },
    },
    {
      item: {
        key: "moderation",
        text: t("moderation"),
        multiLevel: true,
        icon: VerifiedUserOutlinedIcon,
        collapse: "openModeration",
        childeren: [
          { key: "moderations", text: t("currentmoderations"), icon: DomainVerificationOutlinedIcon },
          { key: "moderationHistory", text: t("moderationhistory"), icon: RuleFolderOutlinedIcon },
        ],
      },
    },
    {
      item: {
        key: "loyaltyMembers",
        text: t("loyaltymembers"),
        multiLevel: true,
        icon: GroupsOutlined,
        collapse: "openLoyaltyMember",
        childeren: [
          { key: "memberDetails", text: t("members"), icon: PersonOutlined },
          { key: "memberCards", text: t("cardstemplates"), icon: CardMembershipOutlined },
          // { key: "cardPrinting", text: t("cardprintingjobs") },
          { key: "membershipTiers", text: t("membershiptiers"), icon: WorkspacePremiumOutlined },
        ],
      },
    },
    {
      item: {
        key: "cms",
        text: t("cms"),
        multiLevel: false,
        collapse: null,
        icon: WebIcon,
        childeren: [
          // { key: "cmsHomePage", text: t("homepage"), icon: HomeOutlined },
          // { key: "cmsStorePage", text: t("storepage"), icon: StoreOutlined },
          // { key: "cmsOffersPage", text: t("offerspage"), icon: LocalOfferOutlined },
          // { key: "cmsEventsPage", text: t("eventspage"), icon: EventAvailableOutlined },
        ],
      },
    },
    {
      item: {
        key: "projects",
        text: t("projects"),
        multiLevel: false,
        icon: InsertChartOutlined,
        collapse: null,
        childeren: [],
      },
    },
    // {
    //   item: {
    //     key: "userGroups",
    //     text: t("usergroups"),
    //     multiLevel: false,
    //     icon: PeopleOutlined,
    //     collapse: null,
    //     childeren: [],
    //   },
    // },
    {
      item: {
        key: "retailerVendor",
        text: t("vendors"),
        multiLevel: false,
        icon: StoreMallDirectoryIcon,
        collapse: null,
        childeren: [],
      },
    },
    {
      item: {
        key: "offers",
        text: t("offers"),
        icon: Redeem,
        multiLevel: false,
        collapse: null,
        childeren: [],
      },
    },
    /*{item:{key:'advertising',text:'Campaigns',icon:CampaignOutlined,multiLevel:false,collapse:null,childeren:[]}},*/
    {
      item: {
        key: "events",
        text: t("events"),
        multiLevel: false,
        icon: EventIcon,
        collapse: null,
        childeren: [],
      },
    },
    {
      item: {
        key: "pushNotification",
        text: t("notifications"),
        icon: NotificationsOutlined,
        multiLevel: false,
        collapse: null,
        childeren: [],
      },
    },
  ];
  const listItems = listItemsAll.filter((items) => {
    const permissionCheck = {
      dashboard: permissions?.reportingPermissions?.read,
      // TODO:: handle moderator permissions 
      moderations: roles.includes("Admin") || roles.includes("Super Admin"),
      moderation: roles.includes("Admin") || roles.includes("Super Admin"),
      moderationHistory: roles.includes("Admin") || roles.includes("Super Admin"),
      clients: roles.includes("Super Admin"),
      memberReport: roles.includes("Admin") || roles.includes("Super Admin"),
      offerReport: permissions?.reportingPermissions?.read,
      offers: permissions?.offerPermissions?.read,
      userPermission: permissions?.userPermissions?.read,
      rolePermission: permissions?.rolePermissions?.read,
      loyaltyMembers: !roles.includes("Member") && (permissions?.loyaltyMemberPermissions?.read
        ? true
        : permissions?.cardPermissions?.read),
      memberDetails: !roles.includes("Member") && permissions?.loyaltyMemberPermissions?.read,
      memberCards: !roles.includes("Member") && permissions?.cardPermissions?.read,
      cardPrinting: !roles.includes("Member") && permissions?.cardPermissions?.read,
      membershipTiers: !roles.includes("Member") && permissions?.loyaltyMemberPermissions?.read,
      // TODO:: Update CMS Permissions
      cms: permissions?.cmsPermissions?.read,
      // cmsHomePage: true,
      // cmsStorePage: true,
      // cmsOffersPage: true,
      // cmsEventsPage: true,
      // cmsBannersPage: true,
      pushNotification: permissions?.pushNotificationPermissions?.read,
      advertising: permissions?.compaignPermissions?.read,
      events: permissions?.eventPermissions?.read,
      retailerVendor: permissions?.retailerPermissions?.read,
      userGroups: permissions?.rolePermissions?.read,
      projects: roles.includes("Super Admin"),
      reporting: permissions?.reportingPermissions?.read,
      management:
        permissions?.userPermissions?.read ||
        permissions?.rolePermissions?.read,
    };
    const filteredChild = items.item.childeren.filter((child) => {
      return permissionCheck[child.key] ? permissionCheck[child.key] : false;
    });
    items.item.childeren = filteredChild;
    return permissionCheck[items.item.key]
      ? permissionCheck[items.item.key]
      : false;
  });
  const location = window.location.pathname
  const sxListItem = {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: 1,
    },
    px: 0,
    mx: 0,
    pl: 2,
  };
  const mxListItem = {
    "&.Mui-selected, &.Mui-selected:hover": {
      color: theme.palette.primary.main,
    },
    mx: 0,
    fontSize: "0.8125rem",
    mt: 0.5,
    pl: 2,
  };

  const handleClick = (e, identifier) => {
    e.ignore = true;
    switch (identifier) {
      case "reporting":
        dispatch(open({ reporting: !openReporting }));
        break;
      case "management":
        dispatch(open({ management: !openManagement }));
        break;
      case "loyaltyMembers":
        dispatch(open({ loyalty: !openLoyaltyMember }));
        break;
      case "moderation":
        dispatch(open({ moderation: !openModeration }));
        break;
      default:
        break;
    }
  };

  const handleSelected = (e, identifier) => {
    if (!e.ignore) {
      if (
        identifier === "loyaltyMembers" &&
        !permissions?.loyaltyMemberPermissions?.read
      ) {
        navigate(routeKeys[identifier][1]);
      } else {
        navigate(routeKeys[identifier][0]);
      }
    }
  };
  return listItems.map((value, index) => {
    return value.item.multiLevel ? (
      <Fragment key={index}>
        <ListItem key={value.item.key} disablePadding>
          <ListItemButton
            onClick={(e) => handleSelected(e, value.item.key)}
            selected={routeKeys[value.item.key].includes(location)}
            sx={{
              display: "flex",
              flexDirection: isRtl ? "row-reverse" : "row",
              ...sxListItem,
              pl: 2,
            }}
          >
            <ListItemIcon
              sx={{
                width: 40,
                height: 25,
                minWidth: 40,
                display: "flex",
                flexDirection: isRtl ? "row-reverse" : "row",
              }}
            >
              <value.item.icon
              sx={{
                color: routeKeys[value.item.key].includes(location)
                  ? theme.palette.primary.contrastText
                  : theme.palette.text.primary
              }}
              />
            </ListItemIcon>
            {value.item.text !== t("moderation") ? (
              <ListItemText
                primaryTypographyProps={{
                  fontWeight: 600,
                  fontSize: "0.875rem",
                }}
                primary={value.item.text}
              />
            ) : (
              <div dir={theme.direction} style={{ flex: 1, display: "flex" }}>
                <Typography
                  fontWeight={600}
                  sx={{ mr: 1.5 }}
                  fontSize={"0.875rem"}
                >
                  {value.item.text}
                </Typography>
                <Badge
                  badgeContent={moderationCount.total}
                  overlap="circular"
                  color="error"
                  anchorOrigin={{
                    horizontal: isRtl ? "left" : "right",
                    vertical: "top",
                  }}
                ></Badge>
              </div>
            )}
            <IconButton onClick={(e) => handleClick(e, value.item.key)}>
              {openValue[value.item.collapse] ? (
                <ExpandLess
                  sx={{ width: 14, height: 14,
                    color: routeKeys[value.item.key].includes(location)
                      ? theme.palette.primary.contrastText
                      : "text"
                   }}
                />
              ) : (
                <ExpandMore
                  sx={{ width: 14, height: 14,
                    color: routeKeys[value.item.key].includes(location)
                      ? theme.palette.primary.contrastText
                      : "text"
                  }}
                />
              )}
            </IconButton>
          </ListItemButton>
        </ListItem>
        <Collapse
          in={openValue[value.item.collapse]}
          timeout="auto"
          unmountOnExit
        >
           {value.item.childeren.map((childValue) => {
            const ChildIcon = childValue.icon;
            return (
              <MenuItem
                key={childValue.key}
                sx={{
                  display: "flex",
                  flexDirection: isRtl ? "row-reverse" : "row",
                  ...mxListItem,
                }}
                onClick={(e) => handleSelected(e, childValue.key)}
                selected={routeKeys[childValue.key].includes(location)}
              >
                {ChildIcon && (
                  <ListItemIcon
                    sx={{
                      minWidth: 28,
                      display: "flex",
                      flexDirection: isRtl ? "row-reverse" : "row",
                      // mr: isRtl ? 0 : 0.5,
                      // ml: isRtl ? 0.5 : 0,
                    }}
                  >
                    <ChildIcon
                      sx={{
                        fontSize: "1.125rem",
                        color: routeKeys[childValue.key].includes(location)
                          ? theme.palette.primary.main
                          : theme.palette.text.secondary,
                      }}
                    />
                  </ListItemIcon>
                )}
                <Typography
                  sx={{
                    fontWeight: routeKeys[childValue.key].includes(location) ? 600 : 400,
                    fontSize: "0.8125rem",
                  }}
                >
                  {childValue.text}
                </Typography>
              </MenuItem>
            );
          })}
        </Collapse>
      </Fragment>
    ) : (
      <ListItem key={value.item.key} disablePadding>
        <ListItemButton
          onClick={(e) => handleSelected(e, value.item.key)}
          selected={routeKeys[value.item.key].includes(location)}
          sx={{
            display: "flex",
            flexDirection: isRtl ? "row-reverse" : "row",
            ...sxListItem,
          }}
        >
          <ListItemIcon
            sx={{
              width: 40,
              height: 25,
              minWidth: 40,
              display: "flex",
              flexDirection: isRtl ? "row-reverse" : "row",
            }}
          >
            <value.item.icon
            sx={{
              color: routeKeys[value.item.key].includes(location)
                ? theme.palette.primary.contrastText
                : theme.palette.text.primary
            }}
            />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              fontWeight: 600,
              fontSize: "0.875rem",
            }}
            primary={value.item.text}
          />
        </ListItemButton>
      </ListItem>
    );
  });
}
export default SideList;
